import { render } from "./TeachersSlide.vue?vue&type=template&id=69092ad0&scoped=true&ts=true"
import script from "./TeachersSlide.vue?vue&type=script&lang=ts"
export * from "./TeachersSlide.vue?vue&type=script&lang=ts"

import "./TeachersSlide.vue?vue&type=style&index=0&id=69092ad0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69092ad0"]])

export default __exports__